import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { PagerService } from '../../../common/pagerService';
import { PageResultDto } from '../../../common/viewModels/GlobalRegistry/UnitsModel';
import { ToastrService } from 'ngx-toastr';
import { LubricantTypesSearchModel } from '../../../common/viewModels/GlobalRegistry/CharacteristicsModel';
import { AmplifyService } from '../../../common/amplify-service';

declare var $: any;
@Component({
    selector: 'lubricanttypes',
    templateUrl: './lubricantcharslist.component.html',
    styleUrls: ['./lubricantcharslist.component.scss']
})

export class LubricantsListComponent implements OnInit {
    lubricantsSearchForm: FormGroup;
    addLubricantForm: FormGroup;
    pager: any = {};
    pagedItems: any[];
    pageResult: PageResultDto;
    id: number;
    isNoRecords: boolean = true;
    length: number = 0;
    pageCount: number = 0;
    mainComponent: any;
    isSubmitted: boolean = false;
    searchFields: LubricantTypesSearchModel = new LubricantTypesSearchModel();

    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute,
        private _mApp: MainAppComponent, private _pageSrvc: PagerService,
        private _toastrService: ToastrService,
        private _amplifyService: AmplifyService
    ) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pageSrvc.pageSizeOptions;
        this.lubricantsSearchForm = this._formBuilder.group({
            Name: ['']
        });
        this.addLubricantForm = this._formBuilder.group({
            LubricantTypeId: [0],
            Name: ['', Validators.compose([Validators.minLength(1), Validators.maxLength(100), Validators.required])]
        });
        this.GetDataFromAmpliy();
        this.setPage(this.pager);
        this.ClearDataInAmplify();

    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetLubricantTypesList(this.pager);
    }

    GetLubricantTypesList(page) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._http.post(this._appUrl.GetLubricantTypesList, this.searchFields)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    var response = data.json();
                    this.length = response.PageResult.TotalRecords;
                    this.pagedItems = response.Result;
                    this.isNoRecords = !(response.Result.length > 0);
                },
                error => {
                    this._mApp.HideLoader();
                    this.pagedItems = null;
                    this.isNoRecords = true;
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    OnSearchSubmit() {
        this.pager.pageIndex = 0;
        this.ConstructSearchData();
        this.setPage(this.pager);
    }

    ConstructSearchData() {
        let searchDto = this.lubricantsSearchForm.value;
        this.searchFields.Name = searchDto.Name;
    }

    Clear() {
        this.addLubricantForm.reset();
    }

    OnReset() {
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.lubricantsSearchForm.reset();
        this.searchFields.Name = '';
        this.setPage(this.pager);
    }

    DeleteLubricant(id: any) {
        this.id = id;
    }

    DeleteLubricantById(id: number) {
        this.SaveDataInAmplify();
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteLubricantType + id)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result, '');
                    this.GetDataFromAmpliy();
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    OnSubmit() {
        this.isSubmitted = true;
        if (this.addLubricantForm.valid) {
            this._mApp.ShowLoader();
            let addLubricant = this.addLubricantForm.value;
            this._http.post(this._appUrl.UpsertLubricantTypes, addLubricant)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result, '');
                        $('#addLubricantModel').modal('toggle');
                        this.Clear();
                        this.setPage(this.pager);
                    },
                    error => {
                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result, '')
                    }
                )
        }
    }

    GetLubricantTypeDetails(id: number) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetLubricantTypeDetails + id)
            .subscribe(
                m => {
                    this._mApp.HideLoader();
                    if (m.json().Result != null) {
                        this.addLubricantForm.setValue(m.json().Result);
                    }
                }, error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    SaveDataInAmplify() {
        this._amplifyService.SetStorage('lubricantsList', this.lubricantsSearchForm.value);
        this._amplifyService.SetStorage('lubricantsList_PageNo', this.pager.pageIndex);
        this._amplifyService.SetStorage('lubricantsList_PageSize', this.pager.pageSize);
    }


    GetDataFromAmpliy() {
        let storedData = this._amplifyService.GetStorage('lubricantsList');
        if (storedData != undefined && storedData != null) {
            this.lubricantsSearchForm.setValue(storedData);
            this.ConstructSearchData();
        }
        // let savedPageSize = this._amplifyService.GetStorage('lubricantsList_PageSize');
        // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pageSrvc.pageSize;
        let pageIndex = this._amplifyService.GetStorage('lubricantsList_PageNo');
        if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
            this.pager.pageIndex = pageIndex;
        else
            this.pager.pageIndex = 0;
    }

    ClearDataInAmplify() {
        this._amplifyService.ClearStorage('lubricantsList');
        this._amplifyService.ClearStorage('lubricantsList_PageNo');
        this._amplifyService.ClearStorage('lubricantsList_PageSize');
    }
}
